import { useEffect, useState } from "react";
import Modal from "@/components/modal";
import ArrowRightIcon from "@heroicons/react/24/solid/ArrowRightIcon";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardHeader,
  Divider,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";

function DashboardAnalyticsModal({
  isAnalyticsModalVisible,
  toggleAnalyticsModal,
  title,
  type,
  list,
}) {
  return (
    <Modal
      open={isAnalyticsModalVisible}
      onClose={toggleAnalyticsModal}
      aria-labelledby="date-modal-title"
      aria-describedby="date-modal-description"
      style={{ maxWidth: "500px" }}
    >
      <Typography
        variant="h6"
        sx={{
          mb: 2,
        }}
      >
        {title}
      </Typography>

      <Box sx={{ width: "100%" }}>
        <Box sx={{ height: "400px", overflowY: "auto" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ textAlign: "center" }}>Name</TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  {type === "sponsored" ? "Clicks" : "Views"}
                </TableCell>
              </TableRow>
            </TableHead>
            {list.length > 0 ? (
              <TableBody>
                {list.map((item, index) => {
                  return (
                    <TableRow hover key={index}>
                      <TableCell sx={{ textAlign: "center" }}>
                        {item.eventRef
                          ? item.eventRef.replaceAll("|", " | ")
                          : item.eventValue}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {item.count}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            ) : (
              <Typography variant="body1" sx={{ textAlign: "center" }}>
                No Data Availbe
              </Typography>
            )}
          </Table>
        </Box>
      </Box>
    </Modal>
  );
}

const tableHeading = {
  make: "Views",
  model: "Views",
  grade: "Views",
  "sponsored-views": "Views",
  sponsored: "Clicks",
  "advertisement-views": "Views",
  "advertisement-clicks": "Clicks",
  "finance-clicks": "Clicks",
};

const DashboardTable = ({ sx, list, title, type }) => {
  const [isAnalyticsModalVisible, setIsAnalyticsModalVisible] = useState(false);

  const toggleAnalyticsModal = () => {
    setIsAnalyticsModalVisible(!isAnalyticsModalVisible);
  };

  return (
    <>
      <DashboardAnalyticsModal
        list={list}
        title={title}
        type={type}
        isAnalyticsModalVisible={isAnalyticsModalVisible}
        toggleAnalyticsModal={toggleAnalyticsModal}
      />
      <Card sx={sx}>
        <CardHeader title={title} />
        <Box>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ textAlign: "center" }}>Name</TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  {tableHeading[type]}
                </TableCell>
              </TableRow>
            </TableHead>
            {list.length > 0 ? (
              <TableBody>
                {list.map((order, index) => {
                  if (index < 5) {
                    return (
                      <TableRow hover key={index}>
                        <TableCell sx={{ textAlign: "center" }}>
                          {order.eventRef
                            ? order.eventRef.replaceAll("|", " | ")
                            : order.eventValue}
                          {type === "finance-clicks" ? order.page : ""}
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          {order.count}
                        </TableCell>
                      </TableRow>
                    );
                  } else {
                    return null;
                  }
                })}
              </TableBody>
            ) : (
              <Typography variant="body1" sx={{ textAlign: "center" }}>
                No Data Availbe
              </Typography>
            )}
          </Table>
        </Box>
        <Divider />
        <CardActions sx={{ justifyContent: "flex-end" }}>
          <Button
            color="inherit"
            endIcon={
              <SvgIcon fontSize="small">
                <ArrowRightIcon />
              </SvgIcon>
            }
            size="small"
            variant="text"
            onClick={toggleAnalyticsModal}
          >
            View all
          </Button>
        </CardActions>
      </Card>
    </>
  );
};

export default DashboardTable;

DashboardTable.prototypes = {
  title: PropTypes.string.isRequired,
  sx: PropTypes.object.isRequired,
  list: PropTypes.array.isRequired,
};
